<ng-container *ngIf="!rowNode['group']">
    <div class="btn-actions h-100 cs-d-flex align-items-center gap-12-pxl"
         *ngIf="params['actions']">
        <ng-container *ngFor="let action of params['actions']">
            <button *ngIf="!action.linkUrl && !isHide(action)"
                    class="btn btn-link p-0-pxl"
                    [disabled]="isDisable(action)"
                    [ngClass]="{'disabled': isDisable(action)}"
                    [tooltip]="action.tooltipText"
                    [placement]="'left'"
                    [isDisabled]="!isDisable(action) || !action.tooltipText"
                    [container]="'body'"
                    (click)="onClickAction(action)">
                <span translate>{{ action.text }}</span>
            </button>

            <!-- for open in new tab  -->
            <a *ngIf="action.linkUrl && !isHide(action)"
               class="btn btn-link p-0-pxl"
               [class.disabled]="isDisable(action)"
               [tooltip]="action.tooltipText"
               [placement]="'left'"
               [container]="'body'"
               [attr.href]="isDisable(action) ? null : getActionUrl(action)"
               [attr.target]="isDisable(action) ? null : '_blank'"
               (click)="onClickLinkAction(action, $event)"
               [isDisabled]="isDisabledTooltip(action) || !action.tooltipText">
                <span translate>{{ action.text }}</span>
            </a>

        </ng-container>
    </div>
</ng-container>
